var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'nuxt-class-component';
import { Provide, Prop } from 'vue-property-decorator';
import Model from 'mixins/model';
var RadioGroup = (function (_super) {
    __extends(RadioGroup, _super);
    function RadioGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.errorBucket = [];
        _this.data = _this.value;
        _this.radio = {
            value: _this.data
        };
        return _this;
    }
    Object.defineProperty(RadioGroup.prototype, "error", {
        get: function () {
            return this.errorBucket.find(function (error) { return error !== true; });
        },
        enumerable: true,
        configurable: true
    });
    RadioGroup.prototype.created = function () {
        var _this = this;
        this.$on('input', function (v) {
            _this.data = v;
            _this.radio.value = v;
            _this.valid();
        });
    };
    RadioGroup.prototype.valid = function () {
        var _this = this;
        this.errorBucket = this.rules.map(function (rule) {
            return typeof rule === 'function' && rule(_this.data);
        });
        return this.error === undefined;
    };
    __decorate([
        Prop({ required: false, default: false })
    ], RadioGroup.prototype, "hint", void 0);
    __decorate([
        Prop({ required: false, default: '' })
    ], RadioGroup.prototype, "hintText", void 0);
    __decorate([
        Prop({ required: false })
    ], RadioGroup.prototype, "value", void 0);
    __decorate([
        Prop({ default: function () { return []; } })
    ], RadioGroup.prototype, "rules", void 0);
    __decorate([
        Provide('radio')
    ], RadioGroup.prototype, "radio", void 0);
    RadioGroup = __decorate([
        Component({
            mixins: [Model],
            methods: {
                validate: function () {
                    return this.valid();
                }
            }
        })
    ], RadioGroup);
    return RadioGroup;
}(Vue));
export default RadioGroup;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/tslint-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/common/RadioGroup.vue
// module id = ./node_modules/ts-loader/index.js!./node_modules/tslint-loader/index.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/common/RadioGroup.vue
// module chunks = 5